import { Controller } from "@hotwired/stimulus";

// Per-row visibility on /admin/plans/from_imports. The `mode` select
// chooses between Skip / Map to existing / Create new; we toggle the
// matching detail block (existing-plan dropdown vs inline create form)
// so admins only see the inputs relevant to their pick.
//
// Each table row is its own scope (data-bulk-plan-mapping-target="row"),
// so the dispatch finds the modeSelect/mapPicker/createForm in the
// nearest row even though the controller binds to the whole page.
export default class extends Controller {
  static targets = [
    "row", "modeSelect", "mapPicker", "createForm",
    "planTypeSelect", "intervalRow", "priceRow", "downPaymentRow", "downPaymentLabel"
  ];

  connect() {
    this.refreshAll();
  }

  refresh(event) {
    this.refreshRow(event.target.closest("tr"));
  }

  refreshAll() {
    this.rowTargets.forEach((row) => this.refreshRow(row));
  }

  refreshRow(row) {
    if (!row) return;
    const select = row.querySelector('[data-bulk-plan-mapping-target="modeSelect"]');
    const map    = row.querySelector('[data-bulk-plan-mapping-target="mapPicker"]');
    const create = row.querySelector('[data-bulk-plan-mapping-target="createForm"]');
    const mode = select?.value;
    if (map)    map.classList.toggle("hidden",    mode !== "map");
    if (create) create.classList.toggle("hidden", mode !== "create");

    // When the row is in Create mode, also enforce plan_type-driven
    // visibility on the price + down_payment inputs.
    if (mode === "create") this.refreshPriceFieldsForRow(row);
  }

  // Called by the plan_type select's change action; delegates to the
  // per-row helper so layout stays scoped to one row at a time.
  refreshPriceFields(event) {
    this.refreshPriceFieldsForRow(event.target.closest("tr"));
  }

  refreshPriceFieldsForRow(row) {
    if (!row) return;
    const planType = row.querySelector('[data-bulk-plan-mapping-target="planTypeSelect"]')?.value;
    const intervalRow    = row.querySelector('[data-bulk-plan-mapping-target="intervalRow"]');
    const priceRow       = row.querySelector('[data-bulk-plan-mapping-target="priceRow"]');
    const downPaymentRow = row.querySelector('[data-bulk-plan-mapping-target="downPaymentRow"]');
    const dpLabel        = row.querySelector('[data-bulk-plan-mapping-target="downPaymentLabel"]');

    const isRecurring = planType === "recurring";
    // Interval + recurring Price are recurring-only.
    if (intervalRow) intervalRow.classList.toggle("hidden", !isRecurring);
    if (priceRow)    priceRow.classList.toggle("hidden",    !isRecurring);

    // Down payment is always visible; the label re-purposes the same
    // input for "Setup fee" (recurring, optional) vs "Price" (one_time /
    // credit_pack, required). Backed by the same Plan#down_payment column.
    if (dpLabel)        dpLabel.textContent = isRecurring ? "Setup" : "Price";
    if (downPaymentRow) downPaymentRow.classList.remove("hidden");
  }
}
